import type {
  CacheConfig,
  HttpStatusConfig,
  ReadyStateConfig,
  TimeoutConfig,
} from './config';

export const TIMEOUTS: TimeoutConfig = {
  CONNECTION_TIMEOUT: 10_000,
  RECONNECTION_TIMEOUT: 15_000,
} as const;

export const HTTP_STATUS: HttpStatusConfig = {
  CLIENT_ERROR_MIN: 400,
  CLIENT_ERROR_MAX: 500,
  RATE_LIMIT: 429,
} as const;

export const READY_STATE: ReadyStateConfig = {
  CLOSED: 0,
  OPEN: 1,
} as const;

export const CACHE: CacheConfig = {
  REGEX_MAX_SIZE: 100,
} as const;

export * from './constants/events';
